module.exports = __webpack_public_path__ + "media/4.e42bb238.mp3";